import actions from "./actions";
import mutations from "./mutations";

export default {
  namespaced: true,
  state: {
    currentPage: 1,
    perPage: 5,
    payload: null,
    employeeReports: [],
    tableHeading: [],
    total: null,
    tableLoading: false,
  },
  actions,
  mutations,
};
